// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-element::after {
  content: '';
  width: 1px;
  height: 10000%;
  display: block;
  background-color: rgb(206, 206, 206);
  overflow: hidden;
  margin-left: -1px;
  z-index: -1;
}

.debug {
  border: solid 1px black;
}
.debug-rec {
  border: solid 1px black;
}
.debug-rec div:nth-child(n) {
  border: solid 1px black;
}



.outlined {
  outline: 2px solid rgb(100, 100, 100);
  border-radius: 2px;
  background: content-box radial-gradient(rgba(22, 199, 52, 0.158), rgba(7, 179, 30, 0.301));
}
.selected-case {
  border-top: 1px solid #00cc03;
  border-bottom: 1px solid #00cc03;
  background: #bce6c3;
}
.not-selected-case {
  background: linear-gradient(-45deg, #80808015 15%, #0000 15%, #0000 35%, #80808015 35%, #80808015 65%, #0000 65%, #0000 85%, #80808015 85%);
  background-size: 24px 24px;
}

.understaffed {
  background: content-box radial-gradient(#ffffff00, #ff910030);
  outline: 1px solid #f97316;
}

.alert-case {
  background: linear-gradient(-45deg, #ff910060 5%, #ffffff00 5%, #ffffff00 45%, #ff910060 45%, #ff910060 55%, #ffffff00 55%, #ffffff00 95%, #ff910060 95%);
  background-size: 20px 20px;
}
.stacked-task {
  background: linear-gradient(-45deg, #ff910060 5%, #ffffff00 5%, #ffffff00 45%, #ff910060 45%, #ff910060 55%, #ffffff00 55%, #ffffff00 95%, #ff910060 95%);
  background-size: 20px 20px;
  outline: 1px solid #f97316;
}
.disable-case .alert {
  background: linear-gradient(-45deg, #ff910060 5%, #ffffff00 5%, #ffffff00 45%, #ff910060 45%, #ff910060 55%, #ffffff00 55%, #ffffff00 95%, #ff910060 95%);
  background: linear-gradient(-45deg, #2f2f2f20 5%, #ffffff00 5%, #ffffff00 45%, #2f2f2f20 45%, #2f2f2f20 55%, #ffffff00 55%, #ffffff00 95%, #2f2f2f20 95%);
  background-size: 20px 20px;
}



.dragable-element {
  cursor: grab;
  cursor: -moz-grab;

  &:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    opacity: .5;
  }
}


.dragging-zone-hover {
  background-color: rgba(0, 191, 166, 0.411);
}

.dragging-grid-hover {
  z-index: 50;
}

.modal-input {
  display: block;
  padding: 0.625rem;
  border-radius: 0.25rem;
  border-width: 1px;
  border-color: #D1D5DB;
  width: 100%;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 1;
  color: #111827;
  background-color: #ffffff;
}

.modal-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: #111827;
}

.form-button {
  display: inline-flex; 
  align-items: center; 
  border-radius: 0.5rem; 
  text-align: center; 
  font-size: 0.875rem;
  line-height: 1.25rem; 
  font-weight: 500; 
  color: #ffffff; 

  padding: 0.5rem; 
  padding-left: 1.5rem;
  padding-right: 1.5rem; 
}

.form-button-cancel {
  display: inline-flex; 
  align-items: center; 
  border-radius: 0.5rem; 
  text-align: center; 
  font-size: 0.875rem;
  line-height: 1.25rem; 
  font-weight: 500; 
  color: #ffffff; 

  padding: 0.5rem; 
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  background-color: #D1D5DB; 
  color: #1F2937; 
  &:hover {
    background-color: #ACA3AF; 
  } 
}

.form-button-validate {
  display: inline-flex; 
  align-items: center; 
  border-radius: 0.5rem; 
  text-align: center; 
  font-size: 0.875rem;
  line-height: 1.25rem; 
  font-weight: 500; 
  color: #ffffff; 

  padding: 0.5rem; 
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  background-color: #2563EB; 
  &:hover {
    background-color: #1D4ED8; 
  } 
}

.form-button-delete {
  display: inline-flex; 
  align-items: center; 
  border-radius: 0.5rem; 
  text-align: center; 
  font-size: 0.875rem;
  line-height: 1.25rem; 
  font-weight: 500; 
  color: #ffffff; 

  padding: 0.5rem; 
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  background-color: #EF4444; 
  &:hover {
    background-color: #B91C1C; 
  } 
}


.overflow-container {
  display: flex;
  flex-flow: row wrap;
  overflow: hidden;
}
.overflow-container div {
  height: 100%;
}
.overflow-container div:first-child {
  width: 0;
}

.overflow-container-col {
  display: flex;
  flex-flow: col wrap;
  overflow: hidden;
}
.overflow-container-col div {
  width: 100%;
}
.overflow-container-col div:first-child {
  heigth: 0;
}



.double_range_slider {
  width: 100%;
  height: 5px;
  margin-top: 10px;
  position: relative;
}

.double_range_slider .value {
  position: absolute;
  top: -27px;
  transition-duration: 100ms;
  color: rgb(75 85 99);
  will-change: left, transform;
}

.slide-input-tick-container {
  width: 0px;
  height: 0px;
  display: flex;
  place-content: center;
}


.double_range_slider input[type=range] {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: none;

  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

input[type=range].slider-range {
  -webkit-appearance: none;
  -moz-appearance: none;

  /*nécessaire pour Chrome */
  padding: 0;
  /* nécessaire pour IE */
  font: inherit;
  outline: none;
  background: none;

  background: #CCC;
  box-sizing: border-box;
  transition: opacity .2s;
  cursor: pointer;
  height: 4px;
  border-radius: 5rem;
}


.custom-slider {
  -moz-appearance: none;
  //-webkit-appearance: none;
  
  height: 13px;
  width: 13px;
  border-radius: 50%;
  //background-color: #069;
  pointer-events: auto;
  cursor: pointer;
  box-shadow: 0 0 .5em #FFF inset;
}

.double_range_slider input::-webkit-slider-thumb {
  -moz-appearance: none;
  //-webkit-appearance: none;
  
  height: 13px;
  width: 13px;
  border-radius: 50%;
  //background-color: #069;
  pointer-events: auto;
  cursor: pointer;
  box-shadow: 0 0 .5em #FFF inset;
  margin-bottom: 1px;
}

.double_range_slider input::-moz-range-thumb {
  -moz-appearance: none;
  //-webkit-appearance: none;
  
  height: 13px;
  width: 13px;
  border-radius: 50%;
  //background-color: #069;
  pointer-events: auto;
  cursor: pointer;
  box-shadow: 0 0 .5em #FFF inset;
  margin-top: 30%;
}

input[type=range].slider-range::-webkit-slider-thumb {
  -moz-appearance: none;
  //-webkit-appearance: none;
  
  height: 13px;
  width: 13px;
  border-radius: 50%;
  //background-color: #069;
  pointer-events: auto;
  cursor: pointer;
  box-shadow: 0 0 .5em #FFF inset;
  padding: 0.25em;
}


.container {
  max-width: 100%;
  max-height: 100%;
  min-height: 100%;
}

body {
  background-color: #fffff8;
}


.react-datepicker__close-icon::after {
  background-color: #e26464 !important;
}

.fade {
  width: 100%;
  position: absolute;
  background: linear-gradient(90deg,
      #fff,
      transparent 10%,
      transparent 90%,
      #fff);
  inset: 0;
}

.dropdown-content {
  visibility: hidden;
}
.dropdown:hover .dropdown-content {
  visibility: visible;
}


.input-none::-webkit-inner-spin-button{
  -webkit-appearance: none;
}


/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0);
}

*::-webkit-scrollbar-thumb {
  background-color: #3b82f6;
  border-radius: 20px;
  border: 2px solid rgb(255, 255, 255);
}

.toastui-calendar-day-view .toastui-calendar-panel:not(.toastui-calendar-time),
.toastui-calendar-week-view .toastui-calendar-panel:not(.toastui-calendar-time) {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 255, 0) rgba(255, 166, 0, 0);
}
.toastui-calendar-panel.toastui-calendar-time{
  overflow: visible !important;
}

.toastui-calendar-timegrid{
  height: 100% !important;
  min-height: 100% !important;
}

.toastui-calendar-event-time{
  border: 0px !important;
}

.masonry-col {
  display: flex;
  flex-wrap: wrap;
}

.masonry-col div {
  flex: 1 0 auto;
}

.toastui-calendar-gridline-half {
  height: 10px;
}

.toastui-calendar-grid-selection-label {
  padding: 0.2rem;
  border-radius: 2px;
  border: 1px solid #515ce6;
  background-color: #fffb;
}`, "",{"version":3,"sources":["webpack://./src/calendar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,UAAU;EACV,cAAc;EACd,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;AAEE;EAAA,uBAAY;AAAA;AAGZ;EAAA,uBAAY;AAAA;;;;AAKd;EACE,qCAAqC;EACrC,kBAAkB;EAClB,0FAA0F;AAC5F;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,2IAA2I;EAC3I,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,yJAAyJ;EACzJ,0BAA0B;AAC5B;AAEE;EAAA,yJAAiB;EAAjB,0BAAiB;EACjB,0BAA0B;AADT;AAIjB;EAAA,yJAAiB;EACjB,yJAAyJ;EACzJ,0BAA0B;AAFT;;;;AAOnB;EACE,YAAY;EAEZ,iBAAiB;;EAEjB;IACE,gBAAgB;IAEhB,qBAAqB;IACrB,WAAW;EACb;AACF;;;AAGA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;;EAEd,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAGE;EAAA,oBAAkB;EAAlB,mBAAkB;EAAlB,qBAAkB;EAAlB,kBAAkB;EAAlB,mBAAkB;EAAlB,oBAAkB;EAAlB,gBAAkB;EAAlB,cAAkB;;EAAlB,eAAkB;EAAlB,oBAAkB;EAAlB,qBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd;IACE,yBAAyB;EAC3B;AALkB;;AASlB;EAAA,oBAAkB;EAAlB,mBAAkB;EAAlB,qBAAkB;EAAlB,kBAAkB;EAAlB,mBAAkB;EAAlB,oBAAkB;EAAlB,gBAAkB;EAAlB,cAAkB;;EAAlB,eAAkB;EAAlB,oBAAkB;EAAlB,qBAAkB;EAClB,yBAAyB;EACzB;IACE,yBAAyB;EAC3B;AAJkB;;AAQlB;EAAA,oBAAkB;EAAlB,mBAAkB;EAAlB,qBAAkB;EAAlB,kBAAkB;EAAlB,mBAAkB;EAAlB,oBAAkB;EAAlB,gBAAkB;EAAlB,cAAkB;;EAAlB,eAAkB;EAAlB,oBAAkB;EAAlB,qBAAkB;EAClB,yBAAyB;EACzB;IACE,yBAAyB;EAC3B;AAJkB;;;AAQpB;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;;;;AAIA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,qBAAqB;AACvB;;;AAGA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;;EAEhB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;;EAErB,0BAA0B;EAC1B,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,gBAAgB;;EAEhB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;;AAGA;EACE,qBAAqB;EACrB,0BAA0B;;EAE1B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,+BAA+B;AACjC;;AAGE;EAAA,qBAAoB;EAApB,0BAAoB;;EAApB,YAAoB;EAApB,WAAoB;EAApB,kBAAoB;EAApB,wBAAoB;EAApB,oBAAoB;EAApB,eAAoB;EAApB,+BAAoB;EACpB,kBAAkB;AADE;;AAKpB;EAAA,qBAAoB;EAApB,0BAAoB;;EAApB,YAAoB;EAApB,WAAoB;EAApB,kBAAoB;EAApB,wBAAoB;EAApB,oBAAoB;EAApB,eAAoB;EAApB,+BAAoB;EACpB,eAAe;AADK;;AAKpB;EAAA,qBAAoB;EAApB,0BAAoB;;EAApB,YAAoB;EAApB,WAAoB;EAApB,kBAAoB;EAApB,wBAAoB;EAApB,oBAAoB;EAApB,eAAoB;EAApB,+BAAoB;EACpB,eAAe;AADK;;;AAKtB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB;;;;WAIS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;;AAGA;EACE,wBAAwB;AAC1B;;;AAGA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;;EAEE,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAIE,aAAa;EAGb,eAAe;AACjB;;AAEA;EAIE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB","sourcesContent":[".grid-element::after {\n  content: '';\n  width: 1px;\n  height: 10000%;\n  display: block;\n  background-color: rgb(206, 206, 206);\n  overflow: hidden;\n  margin-left: -1px;\n  z-index: -1;\n}\n\n.debug {\n  border: solid 1px black;\n}\n.debug-rec {\n  @apply debug;\n}\n.debug-rec div:nth-child(n) {\n  @apply debug;\n}\n\n\n\n.outlined {\n  outline: 2px solid rgb(100, 100, 100);\n  border-radius: 2px;\n  background: content-box radial-gradient(rgba(22, 199, 52, 0.158), rgba(7, 179, 30, 0.301));\n}\n.selected-case {\n  border-top: 1px solid #00cc03;\n  border-bottom: 1px solid #00cc03;\n  background: #bce6c3;\n}\n.not-selected-case {\n  background: linear-gradient(-45deg, #80808015 15%, #0000 15%, #0000 35%, #80808015 35%, #80808015 65%, #0000 65%, #0000 85%, #80808015 85%);\n  background-size: 24px 24px;\n}\n\n.understaffed {\n  background: content-box radial-gradient(#ffffff00, #ff910030);\n  outline: 1px solid #f97316;\n}\n\n.alert-case {\n  background: linear-gradient(-45deg, #ff910060 5%, #ffffff00 5%, #ffffff00 45%, #ff910060 45%, #ff910060 55%, #ffffff00 55%, #ffffff00 95%, #ff910060 95%);\n  background-size: 20px 20px;\n}\n.stacked-task {\n  @apply alert-case;\n  outline: 1px solid #f97316;\n}\n.disable-case .alert {\n  @apply alert-case;\n  background: linear-gradient(-45deg, #2f2f2f20 5%, #ffffff00 5%, #ffffff00 45%, #2f2f2f20 45%, #2f2f2f20 55%, #ffffff00 55%, #ffffff00 95%, #2f2f2f20 95%);\n  background-size: 20px 20px;\n}\n\n\n\n.dragable-element {\n  cursor: grab;\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n\n  &:active {\n    cursor: grabbing;\n    cursor: -webkit-grabbing;\n    cursor: -moz-grabbing;\n    opacity: .5;\n  }\n}\n\n\n.dragging-zone-hover {\n  background-color: rgba(0, 191, 166, 0.411);\n}\n\n.dragging-grid-hover {\n  z-index: 50;\n}\n\n.modal-input {\n  display: block;\n  padding: 0.625rem;\n  border-radius: 0.25rem;\n  border-width: 1px;\n  border-color: #D1D5DB;\n  width: 100%;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  line-height: 1;\n  color: #111827;\n  background-color: #ffffff;\n}\n\n.modal-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 500;\n  color: #111827;\n}\n\n.form-button {\n  display: inline-flex; \n  align-items: center; \n  border-radius: 0.5rem; \n  text-align: center; \n  font-size: 0.875rem;\n  line-height: 1.25rem; \n  font-weight: 500; \n  color: #ffffff; \n\n  padding: 0.5rem; \n  padding-left: 1.5rem;\n  padding-right: 1.5rem; \n}\n\n.form-button-cancel {\n  @apply form-button;\n  background-color: #D1D5DB; \n  color: #1F2937; \n  &:hover {\n    background-color: #ACA3AF; \n  }\n}\n\n.form-button-validate {\n  @apply form-button;\n  background-color: #2563EB; \n  &:hover {\n    background-color: #1D4ED8; \n  }\n}\n\n.form-button-delete {\n  @apply form-button;\n  background-color: #EF4444; \n  &:hover {\n    background-color: #B91C1C; \n  }\n}\n\n\n.overflow-container {\n  display: flex;\n  flex-flow: row wrap;\n  overflow: hidden;\n}\n.overflow-container div {\n  height: 100%;\n}\n.overflow-container div:first-child {\n  width: 0;\n}\n\n.overflow-container-col {\n  display: flex;\n  flex-flow: col wrap;\n  overflow: hidden;\n}\n.overflow-container-col div {\n  width: 100%;\n}\n.overflow-container-col div:first-child {\n  heigth: 0;\n}\n\n\n\n.double_range_slider {\n  width: 100%;\n  height: 5px;\n  margin-top: 10px;\n  position: relative;\n}\n\n.double_range_slider .value {\n  position: absolute;\n  top: -27px;\n  transition-duration: 100ms;\n  color: rgb(75 85 99);\n  will-change: left, transform;\n}\n\n.slide-input-tick-container {\n  width: 0px;\n  height: 0px;\n  display: flex;\n  place-content: center;\n}\n\n\n.double_range_slider input[type=range] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: none;\n\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\ninput[type=range].slider-range {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  /*nécessaire pour Chrome */\n  padding: 0;\n  /* nécessaire pour IE */\n  font: inherit;\n  outline: none;\n  background: none;\n\n  background: #CCC;\n  box-sizing: border-box;\n  transition: opacity .2s;\n  cursor: pointer;\n  height: 4px;\n  border-radius: 5rem;\n}\n\n\n.custom-slider {\n  -moz-appearance: none;\n  //-webkit-appearance: none;\n  \n  height: 13px;\n  width: 13px;\n  border-radius: 50%;\n  //background-color: #069;\n  pointer-events: auto;\n  cursor: pointer;\n  box-shadow: 0 0 .5em #FFF inset;\n}\n\n.double_range_slider input::-webkit-slider-thumb {\n  @apply custom-slider;\n  margin-bottom: 1px;\n}\n\n.double_range_slider input::-moz-range-thumb {\n  @apply custom-slider;\n  margin-top: 30%;\n}\n\ninput[type=range].slider-range::-webkit-slider-thumb {\n  @apply custom-slider;\n  padding: 0.25em;\n}\n\n\n.container {\n  max-width: 100%;\n  max-height: 100%;\n  min-height: 100%;\n}\n\nbody {\n  background-color: #fffff8;\n}\n\n\n.react-datepicker__close-icon::after {\n  background-color: #e26464 !important;\n}\n\n.fade {\n  width: 100%;\n  position: absolute;\n  background: linear-gradient(90deg,\n      #fff,\n      transparent 10%,\n      transparent 90%,\n      #fff);\n  inset: 0;\n}\n\n.dropdown-content {\n  visibility: hidden;\n}\n.dropdown:hover .dropdown-content {\n  visibility: visible;\n}\n\n\n.input-none::-webkit-inner-spin-button{\n  -webkit-appearance: none;\n}\n\n\n/* Works on Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n*::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0);\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: #3b82f6;\n  border-radius: 20px;\n  border: 2px solid rgb(255, 255, 255);\n}\n\n.toastui-calendar-day-view .toastui-calendar-panel:not(.toastui-calendar-time),\n.toastui-calendar-week-view .toastui-calendar-panel:not(.toastui-calendar-time) {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 255, 0) rgba(255, 166, 0, 0);\n}\n.toastui-calendar-panel.toastui-calendar-time{\n  overflow: visible !important;\n}\n\n.toastui-calendar-timegrid{\n  height: 100% !important;\n  min-height: 100% !important;\n}\n\n.toastui-calendar-event-time{\n  border: 0px !important;\n}\n\n.masonry-col {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.masonry-col div {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1 0 auto;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n}\n\n.toastui-calendar-gridline-half {\n  height: 10px;\n}\n\n.toastui-calendar-grid-selection-label {\n  padding: 0.2rem;\n  border-radius: 2px;\n  border: 1px solid #515ce6;\n  background-color: #fffb;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
